import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/auth.service';
import { faCog, faSignOut, faUser } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'sn-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(private router: Router, private authService: AuthenticationService) {}

  userIcon = faUser;
  settingsIcon = faCog;
  signoutIcon = faSignOut;

  currentUser = this.authService.currentUser();
  ngOnInit() {
    this.openMobileMenu = false;
  }


  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/auth']);

  }
}
